import {Component, EventEmitter, Inject, Input, NgZone, OnDestroy, OnInit, Output, Renderer2,} from '@angular/core';
import {DOCUMENT} from '@angular/common';

declare global {
  interface Window {
    turnstile: any;
    onloadTurnstileCallback: () => void;
  }
}

@Component({
  selector: 'app-turnstile',
  templateUrl: './turnstile.component.html',
  styleUrls: ['./turnstile.component.scss'],
})
export class TurnstileComponent implements OnInit, OnDestroy {
  @Input() siteKey: string | null = null;
  @Input() action: string | null = null;
  @Input() theme: 'light' | 'dark' | 'auto' = 'auto';
  @Input() size: 'normal' | 'compact' | 'flexible' = 'flexible';

  @Output() resolved = new EventEmitter<string | null>();

  private widgetId: string | null = null;

  constructor(
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    private zone: NgZone
  ) {}

  ngOnInit(): void {
    if (this.siteKey) {
      window.onloadTurnstileCallback = () => {
        this.renderWidget();
      };

      const script = this.renderer.createElement('script');
      script.src = `https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onloadTurnstileCallback&render=explicit`;
      script.async = true;
      script.defer = true;
      this.renderer.appendChild(this.document.head, script);
    } else {
      console.error('Turnstile siteKey no fue proporcionada.');
    }
  }

  ngOnDestroy(): void {
    if (this.widgetId) {
      window.turnstile?.remove(this.widgetId);
    }
  }

  private renderWidget(): void {
    if (!this.siteKey) return;

    this.zone.run(() => {
      this.widgetId = window.turnstile.render('#turnstile-container', {
        sitekey: this.siteKey,
        action: this.action,
        theme: this.theme,
        size: this.size,
        callback: (token: string) => {
          this.resolved.emit(token);
        },
        'error-callback': (errorCode: string) => {
          console.error(`Error de Turnstile: ${errorCode}`);
          this.resolved.emit(null);
        },
        'expired-callback': () => {
          this.resolved.emit(null);
        },
      });
    });
  }

  public resetWidget(): void {
    if (this.widgetId) {
      window.turnstile.reset(this.widgetId);
    }
  }
}
